/**
 * The Documents screen's API handle.
 *
 * The documents calls — the paginated list, the OCR-text tab and the three
 * document-scoped mutations (re-classify, correct the category, send back to
 * review) — live on the shared, session-aware data layer in
 * {@link module:api/resources}. This module is a thin hook that hands the
 * screen that `documents` slice, so every call runs through the ONE app client
 * with its single bearer token and 401-to-/login behaviour.
 */
import { useSession } from '../../auth/session';
import type {
  DocumentsApi,
  DocumentsPage,
  ExportJobView,
  ExportRequestBody,
  ListDocumentsParams,
} from '../../api/resources';

export type { DocumentsApi, DocumentsPage, ExportJobView, ExportRequestBody, ListDocumentsParams };

/** The Documents API bound to the live session (token + 401 self-heal). */
export function useDocumentsApi(): DocumentsApi {
  return useSession().api.documents;
}
